import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthGuard} from './core/guards/auth.guard';
import {LayoutContainerComponent} from './layout/layout-container/layout-container.component';
import {PublicLayoutComponent} from './layout/public-layout/public-layout.component';

const routes: Routes = [
    {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
    },
    {
        path: '',
        component: LayoutContainerComponent,
        canActivate: [AuthGuard],
        children: [
            {
                path: '',
                loadChildren: () => import('./pages/modules/modules.module').then(m => m.ModulesModule)
            },
            {
                path: '',
                loadChildren: () => import('./pages/footer-links/footer-links.module').then(m => m.FooterLinksModule)
            }
        ]
    },
    {
        path: '',
        component: PublicLayoutComponent,
        children: [
            {path: 'auth', loadChildren: () => import('./pages/auth/auth.module').then(m => m.AuthModule)},
            {path: '', loadChildren: () => import('./pages/errors/errors.module').then(m => m.ErrorsModule)}
        ]
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled'})],
    exports: [RouterModule],
})
export class AppRoutingModule {
}
